import { AD_POSITION } from "@/constants/ads";
import useAppStore from "@/context/store";
import { useMemo } from "react";

export function useBannerAds() {
  const { ads } = useAppStore(({ ads }) => ({ ads }));

  const bannerAd = useMemo(() => {
    return Array.isArray(ads)
      ? ads.find((ad) => ad?.position?.id === AD_POSITION.TOP)
      : null;
  }, [ads]);

  const bannerPageAd = useMemo(() => {
    return Array.isArray(ads)
      ? ads.find((ad) => ad?.position?.id === AD_POSITION.TOP_PAGE)
      : null;
  }, [ads]);

  return {
    bannerAd,
    bannerPageAd,
    currentAd: bannerPageAd || bannerAd,
  };
}
